import tw from 'twin.macro';

import { Button } from '@components/Button';
import { useMegaphoneOnboardContext } from '@account_module/context/MegaphoneOnboardContext';
import { OnboardingInputType } from '@account_module/types/Onboarding';
const InlineButton = tw(
  Button.Primary
)`w-[34px] h-[34px] min-w-[34px] min-h-[34px] flex items-center justify-center bg-transparent text-text-muted-2 border border-solid border-primary transition-all duration-150`;

const InlineButtonCopy = tw.span`flex items-center justify-center w-[28px] h-[28px] bg-secondary border border-solid border-primary rounded font-normal transition-all duration-150`;

export const SidebarToggler = ({ dataKey }: { dataKey: OnboardingInputType }) => {
  const { isSidebarVisible, setIsSidebarVisible, setSelectedInput, selectedInput } =
    useMegaphoneOnboardContext();

  const isActive = isSidebarVisible && selectedInput === dataKey;

  const toggleOnboardSidebar = () => {
    if (isActive) {
      setIsSidebarVisible(false);
    } else {
      setSelectedInput(dataKey);
      setIsSidebarVisible(true);
    }
  };

  return (
    <InlineButton
      type='button'
      css={[isActive && tw`bg-secondary border-accent`]}
      onClick={toggleOnboardSidebar}>
      <InlineButtonCopy css={[isActive && tw`bg-accent border-accent text-white`]}>
        ?
      </InlineButtonCopy>
    </InlineButton>
  );
};
